import { CLASS_NAME_DEFAULT } from "../../../../constants"
import Form from "../../../form"

type Props = {
  globalFilter: string
  searchPlaceholder?: string
  onSearch: (value: string | number) => void
  children?: React.ReactNode
  className?: string
}

const SearchBar = ({
  globalFilter,
  onSearch,
  searchPlaceholder,
  children,
  className = CLASS_NAME_DEFAULT
}: Props) => (
  <div
    className={`${className} lg:flex items-center bg-white pb-4 lg:-mt-[54px] sm:-mt-[108px] -mt-[118px]`}
  >
    <Form.SearchInput
      wrapperClassName="w-full lg:w-auto mb-3 lg:mb-0"
      placeholder={searchPlaceholder ?? ""}
      value={globalFilter ?? ""}
      onSearch={onSearch}
      className="lg:min-w-[300px]"
    />
    <div className="flex items-center w-full">{children}</div>
  </div>
)

export default SearchBar
